export const tariffTypes = [
  {label: "стандарт", value: "STANDARD"},
  {label: "со скидкой", value: "DISCOUNT"}
];